import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { IUserProps } from '../common/data/userDummyData';
import Cookies from 'js-cookie';
import { getAPI } from '../apis/backend/apiNode';
import apiFor from '../apis/backend/apiInterceptor';
import { Navigate } from 'react-router-dom';
import { MailMenu } from 'gestioneerMenu';
import { io, Socket } from 'socket.io-client';

const api = apiFor('/coreService');
const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
	// Initialize userData from localStorage
	const [userData, setUserData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [socket, setSocket] = useState(null);

	const handleLogout = async () => {
		try {
			if (socket) socket.disconnect();
			await api.post('/moduleCore/auth/logout');
			// window.location.href = '/auth-pages/login';
		} catch (error) {
		} finally {
			setUserData(null);
			setSocket(null)
			if (window.location.pathname !== '/auth-pages/login') {
				return <Navigate to='/auth-pages/login' replace />;
			}
		}
	};
	useEffect(() => {
		const handleBeforeUnload = () => {
			if (socket) {
				socket.disconnect();
			}
		};

		// Listen for tab close or refresh
		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [socket]);
	useEffect(() => {
		const checkAuthStatus = async () => {
			try {
				const response = await getAPI('user', '/me');
				setUserData(response);

			} catch (error) {
				setUserData(null);
			} finally {
				setLoading(false);
			}
		};
		if (window.location.pathname.startsWith("/" + MailMenu.acceptDevis.path) || window.location.pathname.startsWith("/" + MailMenu.paiement.path)) {
			setLoading(false);
			return;
		}

		!!loading && checkAuthStatus();
	}, [loading]);

	useEffect(() => {
		// On ne se connecte que si userData est disponible et qu'on n'a pas déjà de socket
		if (!!userData?.id && !socket) {
			console.log("userData", userData)
			const namespaceUrl = "/users";

			const newSocket = io(`https://back.essuivi.com/users`, {
				query: {
					userId: userData.id,
					userName: userData.name,
					ringover_id: userData?.ringover_id || ""
				},

				transports: ['websocket'], // Try starting with polling
				upgrade: false,
				reconnection: true,
				reconnectionAttempts: 10,
				timeout: 20000
			});

			newSocket.on("connect", () => {
				console.log("✅ Connected to /users via /coreService proxy");
			});

			newSocket.on("connect_error", (err) => {
				console.error("❌ Proxy Connection Error:", err.message);
			});
			// --- MESSAGE LISTENERS ---

			setSocket(newSocket);

			// Cleanup : Déconnexion si le composant est unmounted ou userData change
			return () => {
				console.log("Cleaning up socket connection...");
				newSocket.off("updateUserList");
				newSocket.disconnect(); // This is vital
			};
		}
	}, [userData]);

	useEffect(() => {
		window.addEventListener('logout', handleLogout);
		return () => {
			window.removeEventListener('logout', handleLogout);
		};
	}, []);

	const value = useMemo(
		() => ({
			userData,
			setUserData,
			loading,
			handleLogout,
			setLoading,
			socket
		}),
		[userData, loading, socket],
	);

	return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};

AuthContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthContext;
